type ApiErrorData = {
  message?: unknown;
  apierror?: { message?: unknown };
};

const toText = (value: unknown): string | undefined => {
  if (typeof value === 'string') {
    return value.trim() !== '' ? value : undefined;
  }
  // NestJS ValidationPipe returns an array of messages for 400 responses.
  if (Array.isArray(value)) {
    const joined = value
      .filter((item): item is string => typeof item === 'string' && item.trim() !== '')
      .join(', ');
    return joined !== '' ? joined : undefined;
  }
  return undefined;
};

/**
 * Extracts a human-readable message from an RTK Query / fetch error.
 *
 * Supports the v1 backend shape `{ statusCode, message, error, timestamp }`
 * and the legacy `{ apierror: { message } }` shape, on an RTK Query error
 * (`error.data`) and on an axios error (`error.response.data`). Returns `fallback` when
 * neither is present.
 */
export const getApiErrorMessage = (error: unknown, fallback: string): string => {
  // RTK Query puts the body in `error.data`, axios (the services built on http-common) in `error.response.data`.
  const e = error as
    | { data?: ApiErrorData; response?: { data?: ApiErrorData } }
    | null
    | undefined;
  const data = e?.data ?? e?.response?.data;
  if (!data || typeof data !== 'object') return fallback;
  return toText(data.message) ?? toText(data.apierror?.message) ?? fallback;
};
